<template>
  <div class="home-border-bottom">
    <div class="banner-container">
      <div class="banner-overlay">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-lg-5 logo-wrapper">
              <h1 class="banner-heading">
                SUICIDE BEREAVEMENT SUPPORT NORFOLK (SBSN) <span class="icon-hexagon"></span>
              </h1>
              <hr />
            </div>
          </div>
        </div>
      </div>
      <div class="row triangle">
        <div class="col-lg-6"></div>
        <div class="col-lg-6">
          <div class="image-partial">
            <div class="img-cover"></div>
          </div>
        </div>
      </div>
    </div>

    <div id="about-us" class="about-us">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h2 class="about-us-title">Suicide Bereavement Support</h2>
            <hr />
            <p>
              <strong>
                Suicide Bereavement Support Norfolk (SBSN) is an independent, Norwich based organisation that provides support, within Norfolk, specifically for people who have been bereaved through, or personally affected by, someone ending their own life.
              </strong>
            </p>
            <p>
              <strong>
                The founding of SBSN as a community group evolved from personal, lived experience of the complex grief of suicide bereavement and our recognition of the sensitive care and compassionate support that is needed for those who are experiencing the emotional turmoil that is suffered by many people who are grieving such a loss.
              </strong>
            </p>
            <p>
              <strong>
                Our desire and commitment to help others comes with appreciation of the sensitivity of individuals' circumstances and the importance of non-judgmental responses in reaching out to support those bereaved by suicide.
              </strong>
            </p>
            <br/>
            <p>
              Benefits of Group Support
            </p>
            <p>
              As a community group we facilitate and lead Suicide Bereavement Support group meetings within Norwich or North Norfolk fortnightly, on a ‘drop in’ basis from 10:30 until 13:30. Please contact us for meeting dates.
            </p>
            <p>
              From our appreciation of the isolation and complex grief that can be experienced, we acknowledge that support groups open a crucial doorway for survivors of suicide loss to feel listened to and understood.
            </p>
            <p>
              Many who are struggling to make sense of what has happened, and cope with the emotional turmoil of their loss, can find some relief in knowing there are others who can relate to their suffering.
            </p>
            <p>
              We offer an informal, friendly and non-judgmental environment where people can feel emotionally protected, and safe to openly share about their loss with no taboos.
            </p>
          </div>
          <div class="col-lg-6 mt-5 mt-lg-0">
            <img class="about-us-img" src="~@/assets/images/woodland.jpg" alt="Woodland" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'home',
  components: {
    VueSlickCarousel
  },
  data() {
    return {
      settings: {
        dots: true,
        autoplay: true,
        'autoplay-speed': 15000,
        dotsClass: 'slick-dots',
        edgeFriction: 0.35,
        draggable: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only if required -->
<style lang="scss">
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

/****************************
    BANNER
*****************************/
.banner-container {
  background-color: $primary;
  position: relative;

  .triangle {
    overflow: hidden;
  }

  .banner-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    color: $white;
    padding-top: 0;
    z-index: 2;
    overflow: hidden;

    .logo-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      @media (min-width: $md-breakpoint) {
        align-items: flex-start;
      }

      .btn {
        background-color: $primary-dark;
    &:hover {
      background-color: $body-text;
      color: $primary;
    }
      }
    }

    @media (max-width: $md-breakpoint) {
      background-color: rgba(0, 0, 0, 0.7);
    }

    @media (max-width: $md-breakpoint) {
      text-align: center;
    }

    .banner-heading {
      color: $body-text;
      font-size: 60px !important;
      text-transform: capitalize;
      font-weight: bold;
      margin-top: -10px;
      margin-bottom: 20px;

      @media (max-width: 992px) {
        font-size: 50px !important;
        margin-top: 50px;
        color: $white;
      }

      @media (max-width: $md-breakpoint) {
        text-align: center;
        margin-top: 0;
      }

      @media (min-width: $lg-breakpoint) {
        font-size: 65px !important;
      }
    }

    hr {
      width: 180px;
      margin: 0;
      margin-bottom: 45px;
      margin-left: auto;
      border-top: 4px solid $primary-dark;
      text-align: center;
      margin-left: 0;
    }

    .banner-content {
      font-weight: 400;
      font-size: 20px;
      margin-bottom: 45px;

      @media (max-width: $md-breakpoint) {
        font-size: 18px;
      }
    }
  }

  >.row {
    margin: 0;

    @media (min-width: $md-breakpoint) {

      :last-child::after,
      :last-child::before {
        content: "";
        display: block;
        position: absolute;
        left: -104px;
        width: 0;
        height: 0;
        border-style: solid;
      }

      // controls the color of the triangle
      *:last-child::after {
        top: -10px;
        border-color: transparent transparent transparent $primary;
        border-bottom-width: 360px;
        border-top-width: 360px;
        border-left: 260px solid $primary;
        left: -164px;
      }

      // controls the white border
      *:last-child::before {
        top: -10px; //0
        border-color: transparent transparent transparent $primary-dark;
        border-bottom-width: 360px;
        border-top-width: 360px;
        border-left: 260px solid $primary-dark;
        left: -160px;
      }
    }

    >* {
      padding: 0;
      position: relative;

      .image-partial {
        margin-left: -160px;

        .img-cover {
          background-image: url("../../assets/images/sunset.jpg");
          height: 700px;
          display: block;
          background-repeat: no-repeat;
          background-position: left center;
          background-size: cover;
        }
      }
    }
  }
}

/****************************
    ABOUT US
*****************************/
.about-us {
  padding: 64px 0;

  &-img {
    border-radius: 0.3rem;
    border: 3px solid $primary;
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: baseline;
  }

  strong {
    font-size: 16px;
  }

  &-title {
    font-size: 40px;
  }
}

/****************************
    ACCRED LOGOS
*****************************/
.accred-logos {
  padding: 64px 0;

  .accred-logo {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 125px;
      width: 100%;
      object-fit: contain;
    }
  }
}

/****************************
    SERVICES
*****************************/
.our-services {
  padding: 64px 0;
  background-color: $secondary;

  &-title {
    font-size: 40px;
    color: $white;
  }

  .service-card {
    &-img {
      height: 255px;
      width: 100%;
      object-fit: cover;
      border-radius: 10px 10px 0 0;
    }

    &-content {
      padding: 60px 40px 30px 40px;
      background-color: $primary;
      color: $white;
      text-align: center;
      border-radius: 0 0 10px 10px;
      position: relative;

      @media (max-width: $sm-breakpoint) {
        padding: 60px 25px 25px 25px;
      }

      @media (min-width: $sm-md-breakpoint) {
        height: 240px;
      }

      @media (min-width: $lg-breakpoint) {
        height: 210px;
      }
    }

    .card-3-content {
      @media (min-width: $sm-md-breakpoint) {
        height: auto;
      }

      @media (min-width: $md-breakpoint) {
        height: 240px;
      }

      @media (min-width: $lg-breakpoint) {
        height: 210px;
      }
    }

    &-icon {
      &-wrapper {
        width: 90px;
        height: 90px;
        background-color: $primary-dark;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: -45px;
        left: calc(50% - 45px);
      }
    }

    &-title {
      font-size: 30px;
      font-weight: bold;
    }

    &-description {
      font-size: 16px;
      margin: 0;
    }

    &:last-child {
      @media (max-width: $md-breakpoint) and (min-width: $sm-md-breakpoint) {
        margin-top: 30px !important;
      }
    }
  }
}

/****************************
    TESTINMONIALS
*****************************/
.testimonials {
  padding: 64px 0 34px;

  &-title {
    font-size: 40px;
  }

  &-single {
    padding: 0 15px;
    margin: 0 -15px;

    &-content {
      cursor: move;
      /* fallback if grab cursor is unsupported */
      cursor: grab;
      cursor: -moz-grab;
      cursor: -webkit-grab;

      &:active {
        cursor: grabbing;
        cursor: -moz-grabbing;
        cursor: -webkit-grabbing;
      }

      .quote-open,
      .quote-close {
        position: relative;
        width: 36px;
        height: 37px;

        svg {
          position: absolute;
          fill: #99a5b7;
          transform: scale(1.5);
        }
      }

      .quote-open {
        svg {
          left: 7px;
          bottom: 10px;
        }
      }

      .quote-close {
        float: right;

        svg {
          right: -18px;
          bottom: 90px;

          @media (max-width: $md-breakpoint) {
            bottom: 70px;
          }

          @media (max-width: $sm-breakpoint) {
            bottom: 65px;
          }
        }
      }

      &-body {
        font-style: italic;
        font-size: 22px;
        margin-bottom: 15px;
      }

      &-author {
        font-weight: 600;
        font-size: 20px;
        color: #969696;
      }
    }
  }

  .slick-dots {
    bottom: 35px;

    li {
      width: 11px;
      height: 11px;

      button {
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background-color: $white;
        border: 1px solid #939598;

        &::before {
          content: "";
          width: 0px;
          height: 0px;
        }
      }

      &.slick-active {
        button {
          background-color: $primary;
          border: 1px solid $primary;
        }
      }
    }
  }
}

.home-border-bottom {
  border-bottom: 3px solid #cff4ec;
}

/****************************
    GET IN TOUCH CTA
*****************************/
.cta-banner {
  background-color: $primary;
  padding: 30px 0;

  &-wrapper {
    display: flex;
    align-items: center;

    &:last-child {
      justify-content: flex-end;

      @media (max-width: $lg-breakpoint) {
        justify-content: center;
      }

      @media (max-width: $md-breakpoint) {
        justify-content: flex-start;
      }
    }
  }

  &-title {
    font-size: 40px;
    font-weight: 500;
    color: $white;
  }

  &-content {
    margin: 0;
    font-size: 18px;
    color: $white;
  }

  &-btn {
    background-color: $primary-dark;
    &:hover {
      background-color: $white;
      color: $primary;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue